export const getNtcSupportUrl = (params: { libraryKey?: string; advantageKey?: string; dyslexic?: boolean; highContrast?: boolean; }): string => {
    const supportUrl = new URL('https://survey.alchemer.com/s3/7151403/Extras-Support-Form');

    if (params?.libraryKey) {
        supportUrl.searchParams.append('dk', params.libraryKey);
    }
    supportUrl.searchParams.append('ak', params.advantageKey || 'null');

    if (params.highContrast) {
        supportUrl.searchParams.append('high-contrast', '1');
    }
    if (params.dyslexic) {
        supportUrl.searchParams.append('dyslexic', '1');
    }

    return supportUrl.toString();
};